import cloneDeep from 'lodash.clonedeep';
import get from 'lodash.get';
import set from 'lodash.set';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import {locales, msbType} from '../../constants/constants';
import { getMetrics, metrics } from './values/metrics';
import { getUserData } from '../../services/API';
import { selectionTypes, reportTypes } from './values/enums';
import trackingCreators from './state/tracking/creators';
import benchmarkCreators from './state/benchmark/creators';
import parentCreators from './state/parent/creators';
import progressCreators from './state/progress/creators';
import diagnosticCreators from './state/diagnostic/creators';
import dyslexiaCreators from './state/dyslexia/creators';
import readingRopeCreators from './state/readingrope/creators'
import skillsDiagnosticCreators from './state/skillsdiagnostic/creators'
import reportCreators from './state/creators';
import { FEATURE_FLAGS } from '../../constants/featureFlags';
// TODO: revert to mapping out reports based on routes?

import SplashScreen from './blocks/Menu/Splash';
import TeacherSelections from './containers/TeacherSelections';
import TrackingReport from './containers/Tracking';
import BenchmarkReport from './containers/Benchmark';
import ProgressReport from './containers/Progress'; //TODO: when we are ready to switch on the progress report UI, import this from index.js and get rid of the placeholder. also switch ` || reportType === reportTypes.PROGRESS` below to turn on teacher selections
import DiagnosticReport from './containers/Diagnostic';
import ParentReport from './containers/Parent';
import DyslexiaRiskReport from './containers/DyslexiaRisk';
import ReadingRopeReport from "./containers/ReadingRope";
import SkillsStatusReport from "./containers/SkillsStatus"
import SkillsDiagnosticReport from "./containers/SkillsDiagnostic"
import Assignment from './containers/Assignment'
import BadgingReport from './containers/Badging'
import BadgeBuilder from './containers/BadgeBuilder'
import ClassProgressReport from './containers/ClassProgress'

// POST MVP // import PlanningReport from './containers/Planning';

import ReportPrintHeader from '../Teacher/Reports/ReportPrintHeader';
import rosterService from './services/roster';
import TutorAssignmentModal from '../../features/tutor_assignment';
import ViewAssignmentsModal from '../../features/tutor_assignment/components/ViewAssignmentsModal';
// Icons
import TrackIcon from '../../images/report_btn_illustrations/TrackIcon';
import BenchmarkIcon from '../../images/report_btn_illustrations/BenchmarkIcon';
import ProgressIcon from '../../images/report_btn_illustrations/ProgressIcon';
import DiagnosticIcon from '../../images/report_btn_illustrations/DiagnosticIcon';
import PlanningIcon from '../../images/report_btn_illustrations/PlanningIcon';
import ParentIcon from '../../images/report_btn_illustrations/ParentIcon';
import ReadingRopeIcon from '../../images/report_btn_illustrations/ReadingRopeIcon.png'
import SkillsDiagnosticIcon from '../../images/report_btn_illustrations/SkillsDiagnosticIcon.png'
import SkillsStatusIcon from '../../images/report_btn_illustrations/SkillStatusIcon.png'
import BadgingIcon from '../../images/report_btn_illustrations/BadgingIcon.png';
import ClassProgressIcon from '../../images/report_btn_illustrations/ClassProgressIcon.png';
import sameScreeningWindowObject from './functions/sameScreeningWindowObject';
import { ReportAnalytics } from './blocks/ReportAnalytics';
import { GetBrandedHiddenReports } from '../../services/BrandingService';
import { CLASSPROGRESS_REPORT_TYPES } from './containers/TeacherSelections/ClassProgressReportType';

/*
ReportingPortal renders a report and TeacherSelections.
*/

// defines props of each report, which determine the available teacher selections.
// TODO refactor to move these props into routes.js
const reports = {
  BENCHMARK: {
    selectionProps: {
      isAggregateReport: true,
      hasScoreScaling: true,
      hasLanguageSelection: true,
      hasScreeningWindowSelection: true,
      hasAssessmentTypeFilter: true,
      pageTitle: "Benchmark Report",
    },
    label: 'Benchmark',
    component: BenchmarkReport,
  },
  TRACKING: {
    selectionProps: {
      isAggregateReport: true,
      hasScoreScaling: false,
      hasLanguageSelection: false,
      hasScreeningWindowSelection: true,
      pageTitle: "Tracking Report",
    },
    label: 'Tracking',
    component: TrackingReport,
  },
  DIAGNOSTIC: {
    selectionProps: {
      hasScoreScaling: false,
      pageTitle: "Instructional Recommendations",
      isAggregateReport: false,
      hasLanguageSelection: true,
    },
    // TODO Diagnostic report
  },
  PARENT: {
    selectionProps: {
      isAggregateReport: false,
      hasScoreScaling: true,
      hasLanguageSelection: true,
      pageTitle: "Parent Report",
      hasSubscoresConfig: true,
      hasAssessmentTypeFilter: true,
    },
    // TODO Parent report
  },
  // POST-MVP
  /*PLANNING: {
    selectionProps: {
      isAggregateReport: false,
      hasScoreScaling: false,
      pageTitle: "Planning Report",
    },
    // TODO Planning report
  },*/
  PROGRESS: {
    selectionProps: {
      isAggregateReport: false,
      hasScoreScaling: true,
      hasLanguageSelection: true,
      pageTitle: "Progress Report",
    },
    // TODO Progress report
  },
  DYSLEXIARISK: {
    selectionProps: {
      isAggregateReport: true,
      hasScoreScaling: false,
      hasReadingRiskType: true,
      hasLanguageSelection: false,
      hasScreeningWindowSelection: true,
      pageTitle: "Dyslexia Risk",
      msbType: msbType.DYSLEXIA,
    },
    label: 'Dyslexia Risk',
    component: DyslexiaRiskReport,
  },
  READINGROPE: {
    selectionProps: {
      isAggregateReport: false,
      hasStatePercentileCutsSelection: true,
      pageTitle: "Reading Rope",
      hasLanguageSelection: true,
    },
    label: "Reading Rope",
    component: ReadingRopeReport,
  },
  SKILLSSTATUS: {
    selectionProps: {
      isAggregateReport: true,
      hasTutorAssignmentButton: true,
      hasViewAssignmentsModalButton: true,
      pageTitle: "Skills Status",
      hasLanguageSelection: true,
    },
    label: "Skills Status",
    component: SkillsStatusReport,
  },
  SKILLSDIAGNOSTIC: {
    selectionProps: {
      isAggregateReport: false,
      hasTutorAssignmentButton: true,
      hasViewAssignmentsModalButton: true,
      pageTitle: "Skills Diagnostic",
      hasLanguageSelection: true,
    },
    label: "Skills Diagnostic",
    component: SkillsDiagnosticReport,
  },
  ASSIGNMENT: {
    selectionProps: {
      pageTitle: 'Assignment'
    },
  },
  BADGING: {
    selectionProps: {
      isAggregateReport: true,
      pageTitle: 'Badging Report',
      hasUsageWindowSelection: true,
      hasBadgingLocaleConfig: true,
    },
  },
  CLASSPROGRESS: {
    selectionProps: {
      isAggregateReport: true,
      hasScoreScaling: true,
      hasLanguageSelection: true,
      hasAssessmentTypeFilter: true,
      hasClassProgressReportType: true,
      pageTitle: "Class Progress Report",
    },
    label: 'Class Progress',
    component: ClassProgressReport,
  }
};


// Splashblock props -
// todo refactor so this isn't necessary
// https://amiralearning.atlassian.net/jira/software/projects/AE/boards/6/backlog?selectedIssue=AE-907&text=refactor
let menuBlocks = [
  {
    type: 'tracking',
    icon: TrackIcon,
    label: 'TRACKING REPORT',
    link: '/teacher/reports/type/tracking',
  },
  {
    type: 'benchmark',
    icon: BenchmarkIcon,
    label: 'BENCHMARK REPORT',
    link: '/teacher/reports/type/benchmark'
  },
  {
    type: 'progress',
    icon: ProgressIcon,
    label: 'PROGRESS REPORT',
    link: '/teacher/reports/type/progress'
  },
  {
    type: "readingrope",
    icon: ReadingRopeIcon,
    label: "INSTRUCTIONAL RECOMMENDATIONS",
    link: "/teacher/reports/type/readingrope",
  },
  {
    type: "skillsstatus",
    icon: SkillsStatusIcon,
    label: "SKILLS STATUS",
    link: "/teacher/reports/type/skillsstatus",
  }, 
  {
    type: "skillsdiagnostic",
    icon: SkillsDiagnosticIcon,
    label: "SKILLS DIAGNOSTIC",
    link: "/teacher/reports/type/skillsdiagnostic",
  },
  {
    type: 'classprogress',
    icon: ClassProgressIcon, // TODO: replace with classprogress icon
    label: 'CLASS PROGRESS REPORT',
    link: '/teacher/reports/type/classprogress',
  },
];

// add feature flag to filter out class progress from being accessible until assets are ready
if (!FEATURE_FLAGS.CLASS_PROGRESS_REPORT) {
  menuBlocks = menuBlocks.filter((menuBlock) => (menuBlock.type !== 'classprogress'));
}

const InvisibleReport = () => {
  return (
    <div className="reports-container reportsHidden"></div>
  )
}

class ReportingPortal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedMetric: getMetrics()[0],
      selectedScale: null,
      selectedBenchmark: null,
      hasFetched: false,
    }

    this.initializeData = this.initializeData.bind(this);
    this.getReportData = this.getReportData.bind(this);
  }

  // When selections change, evaluate whether a report needs to be loaded or rescaled.
  //
  // Note: component is updated immediately to pull default scale and benchmark based on default metric.
  // Therefore, calling fetchReport in componentDidMount is currently unnecessary.
  // TODO: refactor this function to be shorter
  componentDidUpdate(prevProps, prevState) {
    // if valid selections, and we're not on the homepage
    let {selectedCurriculum, selectedMetric, selectedEquating, selectedScale, selectedBenchmark, selectedClass, selectedStudent, selectedLocale, selectedScreeningWindow, selectedStatePercentileCuts, selectedAssessmentTypeFilter, reportConfig, parentReport} = this.props;

    if(!(selectedMetric && selectedScale && selectedBenchmark && selectedClass) || !this.props.match.params.report) {
      return;
    }

    // Determine isAggregateReport
    let reportType = this.props.match.params.report.toUpperCase(); // TODO harden this line of code
    let isAggregateReport = reports[reportType] && reports[reportType].selectionProps.isAggregateReport;

    // Don't fetch data if we're looking at an individual report without a selected student
    if(!selectedStudent && !isAggregateReport && (reportType != reportTypes.READINGROPE)) {
      return;
    }

    // Don't fetch if we have an incompatible combo of report type + metric
    if((reportType != reportTypes.DYSLEXIARISK && selectedMetric && selectedMetric.value == 'DRI') ||
      (reportType == reportTypes.DYSLEXIARISK && selectedMetric && selectedMetric.value != 'DRI')){
      return;
    }

    // Determine whether to scale or fetch
    let fetch = false;
    let scale = false;
    // TODO optimize these fetch/scale conditions
    if(isAggregateReport && ((!prevProps.selectedClass || prevProps.selectedClass.value !== selectedClass.value))){
      fetch = true;
    // TODO change this else if to accomodate custom benchmark in progress report
    } else if (selectedStudent && !isAggregateReport && (!prevProps.selectedStudent || prevProps.selectedStudent.value !== selectedStudent.value)) {
      fetch = true;
    } else if (!prevProps.selectedMetric || prevProps.selectedMetric.value !== selectedMetric.value ||
               !prevProps.selectedScale || prevProps.selectedScale.value !== selectedScale.value) {
      fetch = true;
    }
    else if(!prevProps.selectedBenchmark || prevProps.selectedBenchmark.value !== selectedBenchmark.value){
      scale = true;

      // refetch when selected benchmark changes in parent report
      if (reportType === reportTypes.PARENT) {
        scale = false;
        fetch = true;
      }
    }

    // for Skills Diagnostic Report
    if(reportType === reportTypes.SKILLSDIAGNOSTIC){
      if(prevProps.selectedCurriculum !== selectedCurriculum){
        fetch = true;
      }
    }

    // for Benchmark Report
    if(prevProps.selectedAssessmentTypeFilter !== selectedAssessmentTypeFilter) {
      fetch = true;
    }

    // for reading rope
    if (prevProps.selectedStudent && !selectedStudent) fetch = true

    // TODO remove this fetch condition once we're equating all scores
    if(selectedEquating && (!prevProps.selectedMetric || prevProps.selectedMetric.value !== selectedMetric.value)) {
      fetch = true;
    }

    if(prevProps.selectedEquating != selectedEquating) {
      fetch = true;
    }

    if(selectedLocale !== prevProps.selectedLocale){
      fetch = true;
    }

    //TODO: combine these conditions that set fetch = true
    if(!sameScreeningWindowObject(prevProps.selectedScreeningWindow, selectedScreeningWindow)){
      fetch = true;
    }

    if(selectedStatePercentileCuts && (!prevProps.selectedStatePercentileCuts || prevProps.selectedStatePercentileCuts.state !== selectedStatePercentileCuts.state)) {
      fetch = true;
    }

    if (reportConfig?.isSubscoresVisible && !prevProps.reportConfig?.isSubscoresVisible && !parentReport?.subscores) {
      fetch = true;
    }

    if (reportConfig?.isTipsVisible && !prevProps.reportConfig?.isTipsVisible && !parentReport?.tips) {
      fetch = true;
    }

    // changed report should always fetch new data.
    // class is assumed, student can be not selected, doesn't seem to change the fetch behavior at all.
    if(prevProps.location.pathname !== this.props.location.pathname){
      fetch = true
    }

    // Patch fix: after reporting data is updated, redo scaling. (See commit message for details.)
    if(prevProps.benchmarkActivities !== this.props.benchmarkActivities){
        scale = true
    }

    this.getReportData(fetch, scale);
  }

  getReportData(fetch, scale, params) {
    //if valid selections
    let {selectedMetric, selectedScale, selectedBenchmark, selectedClass, selectedScreeningWindow, selectedStatePercentileCuts,selectedDistrict} = this.props;
    if(!(selectedMetric && selectedScale && selectedBenchmark && selectedClass) ||
        isEmpty(selectedBenchmark) || isEmpty(selectedScale) || isEmpty(selectedMetric) ||
        (this.props.students.length > 0 && this.props.benchmarks.length == 0)) {
      return;
      // TODO check for !isAggregate instead
    } else if(this.props.match.params.report == 'progress' || this.props.match.params.report == 'parent' || this.props.match.params.report == 'diagnostic') {
      if(!this.props.selectedStudent) {
        return;
      }
    } else if((this.props.match.params.report != 'dyslexiarisk' && selectedMetric && selectedMetric.value == 'DRI')
      || (this.props.match.params.report == 'dyslexia' && selectedMetric && selectedMetric.value != 'DRI')) {
      this.props.clearReport(this.props.match.params.report);
      return;
    }

    // If this isn't an ORF report, don't fetch equated activities
    // TODO, deprecate this once additional metrics are equated
    let equated = this.props.selectedEquating;
    let locale = this.props.selectedLocale;
    const { selectedAssessmentTypeFilter } = this.props;

    // If we haven't fetched a report since the component mounted, fetch one
    if(!this.state.hasFetched) {
      fetch = true;
      scale = false;
      this.setState({
        hasFetched: true,
      });
    }

    // TODO clean up redux so that this check isn't necessary
    let classroomId = this.props.selectedClass.value ? this.props.selectedClass.value : this.props.selectedClass.ui.value;
    const schoolId = this.props.selectedSchool.id;

    // based on the currently active report
    // TODO simplify this to two lines of code for all reports (perhaps by storng the individual methods in an object)
    switch(this.props.match.params.report) {
      case 'benchmark': // Load/Scale Benchmark report
        if(fetch){
          this.props.fetchBenchmarkReport(classroomId,selectedMetric.value,selectedScale.value,selectedBenchmark,this.props.customBenchmarks, equated, locale, selectedStatePercentileCuts);
        } else if(scale){
          this.props.scaleBenchmarkReport(this.props.benchmarkActivities,selectedMetric.value,selectedScale.value,selectedBenchmark,this.props.customBenchmarks, locale, selectedStatePercentileCuts);
        }
        break;
      case 'tracking': // Load Tracking report
        if(fetch){
          this.props.fetchTrackingReport(schoolId, this.props.students, selectedScreeningWindow, selectedDistrict,params);
        }
        break;
      // TODO enable this data fetching when the corresponding report is turned on
      case 'parent':
        // Note: fetch and scale progress report, since it's a subset of the parent report
        if(fetch){
          this.props.fetchParentReport(this.props.selectedStudent, this.props.selectedMetric, this.props.selectedBenchmark, this.props.customBenchmarks, this.props.reportConfig, equated, locale, selectedStatePercentileCuts, selectedAssessmentTypeFilter);
          this.props.fetchProgressReport(this.props.selectedStudent,selectedMetric.value,selectedScale.value,selectedBenchmark, this.props.customBenchmarks,equated, locale, {skipARM: true}, selectedStatePercentileCuts);
        } else if(scale){
          this.props.scaleProgressReport(this.props.progressActivities,selectedMetric.value,selectedScale.value,selectedBenchmark,this.props.selectedStudent, this.props.customBenchmarks, locale, selectedStatePercentileCuts);
        }
        break;
      case 'progress': // Load/Scale Progress report
        // TODO integrate student picker
        if(fetch){
          this.props.fetchProgressReport(this.props.selectedStudent,selectedMetric.value,selectedScale.value,selectedBenchmark, this.props.customBenchmarks, equated, locale, {}, selectedStatePercentileCuts);
        } else if(scale){
          this.props.scaleProgressReport(this.props.progressActivities,selectedMetric.value,selectedScale.value,selectedBenchmark,this.props.selectedStudent, this.props.customBenchmarks, locale, selectedStatePercentileCuts);
        }
        break;
      case 'diagnostic': // Load Diagnostic report
        fetch && this.props.fetchDiagnoseReport(this.props.selectedStudent, locale);
        break;
      case 'dyslexiarisk': // Load/Scale Dyslexia Risk report
        if(fetch){
          this.props.fetchDyslexiaReport(classroomId, selectedBenchmark, locale);
        }else if(scale){
          this.props.scaleDyslexiaReport(this.props.dyslexiaReport, selectedBenchmark, locale);
        }
        break;
      case 'readingrope':
        if (fetch) this.props.fetchReadingRopeReport(classroomId, this.props.selectedStudent, selectedStatePercentileCuts)
        break;
      case 'skillsstatus':
        // data fetch is handled within the report component itself for pagination reasons.
        break;
      case 'skillsdiagnostic':
        if (fetch) this.props.fetchSkillsDiagnosticReport(this.props.selectedStudent)
        break;
      case 'badging':
        // data fetch is handled within the report component
        break;
      case 'classprogress':
        // data fetch is handled within the report component
        break;
      default:
        console.log('invalid report type: ', this.props.match.params);
        break;
    }
  }

  initializeData(params) {
    this.getReportData(true, false, params);
  }

  getMenuItems() {
    const menuItems = cloneDeep(menuBlocks);

    const {dyslexiaEnabled, badgingEnabled, parentReportEnabled} = getUserData();

    // change menu blocks depending on user permissions
    if(dyslexiaEnabled) {
      menuItems.push({
        type: 'dyslexiarisk',
        icon: BenchmarkIcon,
        label: 'DYSLEXIA RISK REPORT',
        link: '/teacher/reports/type/dyslexiarisk'
      });
    }

    if (badgingEnabled) {
      menuItems.push({
        type: 'badging',
        icon: BadgingIcon,
        label: 'BADGING REPORT',
        link: '/teacher/reports/type/badging'
      })
    }

    if (parentReportEnabled) {
      menuItems.push({
        type: 'parent',
        icon: ParentIcon,
        label: 'PARENT REPORT',
        link: '/teacher/reports/type/parent'
      })
    }

    const hiddenReports = GetBrandedHiddenReports();

    if (hiddenReports) {
      return menuItems.filter((menuBlock) => !hiddenReports.includes(menuBlock.type));
    }
    return menuItems;
  }

  render () {
    // get available menu items
    let menuItems = this.getMenuItems();

    // check which report type this is
    let report;
    let reportType;
    let hideScore;
    let title;

    const { district } = getUserData();
    const districtId = district?.id;
    const schoolId = this.props.selectedSchool?.id;

    switch(this.props.match.params.report) {
      case 'benchmark':
        report = <BenchmarkReport
                  students={this.props.students}
                  initializeData={() => this.initializeData()} />;
        reportType = reportTypes.BENCHMARK;
        break;
      case 'tracking':
        report = <TrackingReport
                  students={this.props.students}
                  initializeData={(params) => this.initializeData(params)}
                  history={this.props.history} />;
        reportType = reportTypes.TRACKING;
        break;
      case 'progress':
        report = <ProgressReport
                  initializeData={() => this.initializeData()}/>;
        reportType = reportTypes.PROGRESS;
        break;
      case 'diagnostic':
        report = <DiagnosticReport
                  initializeData={() => this.initializeData()}/>;
        reportType = reportTypes.DIAGNOSTIC;
        break;
      // case 'planning': // POST MVP
      //   report = <PlanningReport />;
      //   reportType = reportTypes.PLANNING;
      //   break;
      case 'parent':
        report = <ParentReport
                  initializeData={() => this.initializeData()}/>;
        reportType = reportTypes.PARENT;
        break;
      case 'dyslexiarisk':
        report = <DyslexiaRiskReport initializeData={() => this.initializeData()}/>;
        reportType = reportTypes.DYSLEXIARISK;
        break;
      case "readingrope":
        report = <ReadingRopeReport initializeData={() => this.initializeData()} history={this.props.history} />;
        reportType = reportTypes.READINGROPE;
        break;
      case "skillsstatus":
        report = <SkillsStatusReport />;
        reportType = reportTypes.SKILLSSTATUS;
        break;
      case "skillsdiagnostic":
        report = <SkillsDiagnosticReport initializeData={() => this.initializeData()} />;
        reportType = reportTypes.SKILLSDIAGNOSTIC;
        break;
      case "assignment":
        return (
          <ContentWrapper>
            <Assignment history={this.props.history} districtId={districtId} schoolId={schoolId} />
          </ContentWrapper>
        )
      case "badging":
        report = <BadgingReport history={this.props.history} />
        reportType = reportTypes.BADGING;
        break;
      case "badge-builder":
        return <BadgeBuilder history={this.props.history} />
      case "classprogress":
        report = <ClassProgressReport history={this.props.history} />
        reportType = reportTypes.CLASSPROGRESS;
        hideScore = true;
        const selectedClassLabel = this.props.selectedClass && this.props.selectedClass.label;
        title = `Class Progress Report for ${selectedClassLabel}`;
        break; 
      default:
        report = null; // not a report (homepage)
        break;
    }
    let isReport = report ? true : false;

    // determine whether we've made the necessary selections to show the report.
    // If not, switch the report out for an invisible container for spacing
    // TODO switch out the OR for isAggregateReport

    // TODO eliminate the need for invisibleReport through css, and add fade in/out
    // TODO enable this codeblock along with progress/parent/diagnosis reports
    if(reports[reportType] && (reportType === reportTypes.PROGRESS || reportType === reportTypes.PARENT || reportType === reportTypes.DIAGNOSTIC) && !reports[reportType].selectionProps.isAggregateReport && !this.props.selectedStudent) {
      report = <InvisibleReport />
    }

    const teacherSelectionTypes = cloneDeep(reports[reportType]?.selectionProps);

    // if thread overview is selected in the class progress report, disable score scaling
    if (this.props.selectedClassProgressReportType === CLASSPROGRESS_REPORT_TYPES.THREAD_OVERVIEW && reportType === reportTypes.CLASSPROGRESS) {
      teacherSelectionTypes.hasScoreScaling = false;
      teacherSelectionTypes.hasAssessmentTypeFilter = false;
    }

    return (
      <div className="reports-root-container">
        <TutorAssignmentModal />
        <ViewAssignmentsModal />
        <Toaster position="bottom-center" />
        <ReportPrintHeader
          selectedStudent={this.props.selectedStudent}
          selectedClass={this.props.selectedClass && this.props.selectedClass.label}
          school={this.props.selectedSchool}
          reportType={reportType}
          isMain={true}
          title={title}
        />
        <ReportAnalytics path={this.props.location.pathname} title={reports[reportType]?.selectionProps?.pageTitle}/>
        <div className="reports-page-wrap">
          {!isReport && <SplashScreen blocks={menuItems} translate />}
          {isReport &&
            <div className='reports-page'>
              <TeacherSelections
                teacherSelectionTypes={teacherSelectionTypes}
                selectedMetric={this.props.selectedMetric}
                selectedScale={this.props.selectedScale}
                selectedBenchmark={this.props.selectedBenchmark}
                selectedEquating={this.props.selectedEquating}
                selectedLocale={this.props.selectedLocale}
                selectedStatePercentileCuts={this.props.selectedStatePercentileCuts}
                history={this.props.history}
                hideScore={hideScore}
                />
                {report}
            </div>
          }
        </div>
      </div>
    )
  }
}

function ContentWrapper(props) {
  return (
    <div className="reports-root-container">
      <div className="reports-page-wrap">
        <div className='reports-page'>
          {props.children}
        </div>
      </div>
    </div>
  )
}

function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

const mapStateToProps = (state) => {
  const { roster } = state.reports;

  return {
    trackingActivities: get(state, 'reports.tracking.report.activities', null),
    benchmarkActivities: get(state, 'reports.benchmark.report.activities', null),
    progressActivities: get(state, 'reports.progress.report.activities', null),
    dyslexiaReport: get(state, 'reports.dyslexia.report.data'),
    parentReport: get(state, 'reports.parent.report.data'),
    students: roster.data && roster.data.student ? roster.data.student : [],
    benchmarks: get(state, 'reports.teacher.benchmarks', []),
    selectedClass: get(state, 'reports.roster.ui.selections.classroom', null),
    selectedEquating: get(state, 'reports.teacher.equatingSelection', true),
    selectedMetric: get(state, 'reports.teacher.selections.metric', {}),
    selectedScale: get(state, 'reports.teacher.selections.scale', {}),
    selectedBenchmark: get(state, 'reports.teacher.selections.benchmark', {}),
    selectedStudent: get(state, 'reports.roster.ui.selections.student', null),
    selectedSchool: get(state, 'reports.roster.ui.selections.school', null),
    selectedDistrict: get(state, 'reports.teacher.district',null),
    customBenchmarks: get(state, 'reports.teacher.customBenchmarks'),
    selectedLocale: get(state, 'reports.teacher.selectedLocale', null),
    selectedAssessmentTypeFilter: get(state, 'reports.teacher.selectedAssessmentTypeFilter', null),
    selectedScreeningWindow: get(state, 'reports.teacher.selectedScreeningWindow', null),
    selectedStatePercentileCuts: get(state, 'reports.teacher.selectedStatePercentileCuts', null),
    selectedCurriculum: get(state, 'reports.teacher.selectedCurriculum.value', null),
    reportConfig: get(state, 'reports.teacher.reportConfig', null),
    selectedClassProgressReportType: get(state, 'reports.teacher.classProgressReportType', null),
  }
};

// TODO cache activities within redux, as opposed to passing them in in order to rescale
const mapDispatchToProps = (dispatch) => ({
  fetchBenchmarkReport: (...args) => dispatch(benchmarkCreators.fetchReport(...args)),
  fetchTrackingReport: (...args) => dispatch(trackingCreators.fetchReport(...args)),
  fetchParentReport: (...args) => dispatch(parentCreators.fetchReport(...args)),
  fetchProgressReport: (...args) => dispatch(progressCreators.fetchReport(...args)),
  fetchDiagnoseReport: (studentId) => dispatch(diagnosticCreators.fetchReport(studentId)),
  fetchDyslexiaReport: (classroomId, selectedBenchmark, selectedLocale) => dispatch(dyslexiaCreators.fetchReport(classroomId, selectedBenchmark, selectedLocale)),
  fetchReadingRopeReport: (classroomId, studentId, selectedStatePercentileCuts) => dispatch(readingRopeCreators.fetchReport(classroomId, studentId, selectedStatePercentileCuts)),
  fetchSkillsDiagnosticReport: (studentId) => dispatch(skillsDiagnosticCreators.fetchSkillsDiagnosticReport(studentId)),
  scaleDyslexiaReport: (report, selectedBenchmark, selectedLocale) => dispatch(dyslexiaCreators.scaleReport(report, selectedBenchmark, selectedLocale)),
  scaleBenchmarkReport: (...args) => dispatch(benchmarkCreators.scaleReport(...args)),
  scaleProgressReport: (...args) => dispatch(progressCreators.scaleReport(...args)),
  clearReport: (reportType) => dispatch(reportCreators.reportClear(reportType)),
});

ReportingPortal.propTypes = {
  trackingActivities: PropTypes.array,
  benchmarkActivities: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportingPortal));
